var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "pram",
          attrs: { model: _vm.pram, "label-width": "100px" },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label:
                          _vm.pram.type == 1 ? _vm.$t("zfmc") : _vm.$t("khyh"),
                        prop: "pay_name",
                        rules: [
                          {
                            required: true,
                            message: "请填写支付名称",
                            trigger: ["blur", "change"],
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: _vm.$t("qsrzfmc") },
                        model: {
                          value: _vm.pram.pay_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.pram, "pay_name", $$v)
                          },
                          expression: "pram.pay_name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("sklx"),
                        rules: [
                          {
                            required: true,
                            message: _vm.$t("qxzzffs"),
                            trigger: ["blur", "change"],
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          model: {
                            value: _vm.pram.type,
                            callback: function ($$v) {
                              _vm.$set(_vm.pram, "type", $$v)
                            },
                            expression: "pram.type",
                          },
                        },
                        [
                          _c("el-option", {
                            attrs: { label: _vm.$t("USDT"), value: 1 },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: _vm.$t("RMB"), value: 2 },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("status") } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  model: {
                    value: _vm.pram.status,
                    callback: function ($$v) {
                      _vm.$set(_vm.pram, "status", $$v)
                    },
                    expression: "pram.status",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: _vm.$t("kaiqi"), value: 1 },
                  }),
                  _vm._v(" "),
                  _c("el-option", {
                    attrs: { label: _vm.$t("guanbi"), value: 0 },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.pram.type == 1
            ? _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("ljdz"),
                    prop: "link_url",
                    rules: [
                      {
                        required: true,
                        message: _vm.$t("qtxljdz"),
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: _vm.$t("qsrljdz") },
                    model: {
                      value: _vm.pram.link_url,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "link_url", $$v)
                      },
                      expression: "pram.link_url",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.pram.type == 2
            ? _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("skxm"),
                            prop: "bank_user_name",
                            rules: [
                              {
                                required: true,
                                message: _vm.$t("qtxlskxm"),
                                trigger: ["blur", "change"],
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: _vm.$t("qtxlskxm") },
                            model: {
                              value: _vm.pram.bank_user_name,
                              callback: function ($$v) {
                                _vm.$set(_vm.pram, "bank_user_name", $$v)
                              },
                              expression: "pram.bank_user_name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("skzh"),
                            prop: "bank_account",
                            rules: [
                              {
                                required: true,
                                message: _vm.$t("qtxlskzh"),
                                trigger: ["blur", "change"],
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: _vm.$t("qtxlskzh") },
                            model: {
                              value: _vm.pram.bank_account,
                              callback: function ($$v) {
                                _vm.$set(_vm.pram, "bank_account", $$v)
                              },
                              expression: "pram.bank_account",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("khwd"),
                            prop: "bank_branch_name",
                            rules: [
                              {
                                required: true,
                                message: _vm.$t("qtxkhwd"),
                                trigger: ["blur", "change"],
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: _vm.$t("qtxkhwd") },
                            model: {
                              value: _vm.pram.bank_branch_name,
                              callback: function ($$v) {
                                _vm.$set(_vm.pram, "bank_branch_name", $$v)
                              },
                              expression: "pram.bank_branch_name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("fjxx"),
                prop: "explain",
                rules: [
                  {
                    required: true,
                    message: "请填写附加信息",
                    trigger: ["blur", "change"],
                  },
                ],
              },
            },
            [
              _c("el-input", {
                attrs: { placeholder: _vm.$t("qsrfjxx") },
                model: {
                  value: _vm.pram.explain,
                  callback: function ($$v) {
                    _vm.$set(_vm.pram, "explain", $$v)
                  },
                  expression: "pram.explain",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("tpewm"), prop: "qrcode" } },
            [
              _c(
                "div",
                { staticClass: "acea-row upLoadPicBox row-middle" },
                [
                  _c(
                    "el-upload",
                    {
                      staticClass: "upload-demo",
                      attrs: {
                        action: "",
                        "http-request": _vm.handleUploadForm,
                        headers: _vm.myHeaders,
                        "show-file-list": false,
                      },
                    },
                    [
                      _vm.pram.qrcode
                        ? _c("div", { staticClass: "pictrue" }, [
                            _c("img", {
                              attrs: { src: _vm.setUrl(_vm.pram.qrcode) },
                            }),
                          ])
                        : _c("div", { staticClass: "upLoad" }, [
                            _c("i", {
                              staticClass: "el-icon-camera cameraIconfont",
                            }),
                          ]),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handlerSubmit("pram")
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.isCreate === 0
                        ? _vm.$t("trueText")
                        : _vm.$t("updateText")
                    )
                  ),
                ]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.close } }, [
                _vm._v(_vm._s(_vm.$t("calcelText"))),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }